import React from "react";
import { Box, Button } from "@mui/material";
import MoreInfo from "../../Components/moreInfo/MoreInfo";
import useIsMobile from "../../hooks/useIsMobile";
import { trackFAQView, trackSignUpClick } from "../../utils/analytics";

const NeedHelp = () => {
  const isMobile = useIsMobile();

  const handleSignUpClick = (source: string) => {
    trackSignUpClick(`faq_${source}`);
    window.location.href = "/cadastro";
  };

  const faqItems = [
    {
      title: "Como funciona?",
      description:
        "Nosso sistema permite que você gerencie reservas de forma simples e eficiente. Cadastre-se, configure suas quadras com horários de funcionamento e valores para cada dia da semana e compartilhe seu link personalizado com seus clientes.",
      source: "como_funciona",
    },
    {
      title: "Como eu pago pela assinatura do Anota Reservas?",
      description:
        "Você pode pagar sua mensalidade via Cartão de Crédito ou Pix, com total segurança. A cobrança é recorrente para sua comodidade.",
      source: "pagamento",
    },
    {
      title: "Como funciona o agendamento online?",
      description:
        "Os clientes acessam seu link personalizado, escolhem a data e horário disponíveis e confirmam a reserva em poucos cliques. Tudo de forma automatizada e sem complicação.",
      source: "agendamento_online",
    },
    {
      title: "Meu cliente precisa pagar online para fazer a reserva?",
      description:
        "Não. Pensamos em um modelo simples para não criar barreiras. Seu cliente agenda de graça e o acerto é feito diretamente com você no local. Com um clique, você pode marcar a reserva como 'Paga' no sistema para seu controle.",
      source: "pagamento_cliente",
    },
  ];

  return (
    <section
      aria-label="Seção de Perguntas Frequentes"
      style={{
        padding: isMobile ? "20px 10px" : "50px 120px",
        margin: "0 auto",
        maxWidth: isMobile ? "100%" : "1090px",
        color: "#22303E",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          padding: isMobile ? "0 10px" : "0",
        }}
      >
        <Box width={isMobile ? "100%" : "65%"}>
          <h2
            style={{
              letterSpacing: "0.1px",
              fontWeight: 600,
              lineHeight: 1.1,
              fontSize: isMobile ? "32px" : "60px",
              fontFamily: "sans-serif",
            }}
          >
            Ficou alguma dúvida?
          </h2>
          <p
            style={{
              letterSpacing: "0.1px",
              color: "#6B7280",
              fontWeight: 400,
              lineHeight: 1.3,
              fontSize: isMobile ? "18px" : "26px",
              fontFamily: "sans-serif",
            }}
          >
            Aqui estão as respostas para suas principais perguntas
          </p>
        </Box>
      </Box>

      <Box marginTop={isMobile ? "20px" : "40px"}>
        {faqItems.map((item, index) => (
          <Box key={index} marginBottom="20px">
            <div onClick={() => trackFAQView(item.source)}>
              <MoreInfo title={item.title} description={item.description} />
            </div>
          </Box>
        ))}
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: "60px",
          padding: "40px 20px",
          background: "linear-gradient(135deg, #226FE2 0%, #0033FF 100%)",
          borderRadius: "20px",
          textAlign: "center",
          color: "#fff",
        }}
      >
        <h3
          style={{
            fontSize: isMobile ? "24px" : "32px",
            fontWeight: 600,
            marginBottom: "15px",
            fontFamily: "sans-serif",
          }}
        >
          Ainda tem dúvidas?
        </h3>
        <p
          style={{
            fontSize: isMobile ? "16px" : "18px",
            marginBottom: "30px",
            maxWidth: "600px",
            opacity: 0.9,
            fontFamily: "sans-serif",
          }}
        >
          Nossa equipe está pronta para te ajudar a implementar o sistema na sua
          quadra
        </p>

        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: "15px",
            alignItems: "center",
          }}
        >
          <Button
            onClick={() => handleSignUpClick("faq_cta")}
            variant="contained"
            sx={{
              background: "#fff",
              color: "#226FE2",
              padding: "14px 32px",
              borderRadius: "30px",
              fontWeight: 600,
              fontSize: "16px",
              textTransform: "none",
              boxShadow: "0 4px 14px rgba(255, 255, 255, 0.3)",
              "&:hover": {
                background: "#f5f5f5",
                transform: "translateY(-2px)",
                boxShadow: "0 6px 20px rgba(255, 255, 255, 0.4)",
              },
              transition: "all 0.3s ease",
            }}
          >
            Começar teste grátis
          </Button>

          <Button
            onClick={() => {
              const phone = "5588992429813";
              const message =
                "Olá, tenho algumas dúvidas sobre o sistema Anota Reservas. Poderia me ajudar?";
              const encodedMessage = encodeURIComponent(message);
              window.location.href = `https://wa.me/${phone}?text=${encodedMessage}`;
            }}
            variant="outlined"
            sx={{
              border: "2px solid #fff",
              color: "#fff",
              padding: "14px 32px",
              borderRadius: "30px",
              fontWeight: 600,
              fontSize: "16px",
              textTransform: "none",
              "&:hover": {
                background: "#fff",
                color: "#226FE2",
                border: "2px solid #fff",
                transform: "translateY(-2px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            Falar no WhatsApp
          </Button>
        </Box>
      </Box>
    </section>
  );
};

export default NeedHelp;
